var tmAjaxActionNonce = '';
tmUtils = function () {
    return {
        showElementsForSelector: function (selector) {
            jQuery(selector).removeClass('c-hidden');
        },
        hideElementsForSelector: function (selector) {
            jQuery(selector).addClass('c-hidden');
        },
        showLoaderForSelector: function (selector) {
            jQuery(selector).addClass('c-btn-loading');
        },
        hideLoaderForSelector: function (selector) {
            jQuery(selector).removeClass('c-btn-loading');
        },
        validateEmailString: function (value) {
            let emailValidateRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return emailValidateRegex.test(value);
        },
        isTmSupportOnline: function () {
            let offset = '-4';
            var d = new Date();
            var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
            let keyWestTime = new Date(utc + (3600000*offset));

            let keyWestTimeHours = keyWestTime.getHours();
            let isCallUsTimeValid = true;
            if (keyWestTimeHours > 22 || keyWestTimeHours < 7) {
                /* closed from 10pm to 7am */
                isCallUsTimeValid = false;
            }
            return isCallUsTimeValid;
        },
        getAjaxRequestNonce: function () {
            return tmAjaxActionNonce;
        },
        getRandomId: function() {
            return Math.floor(Math.random() * 26) + Date.now()
        },
        getCurrentPlainDomain: function () {
            return location.host.replace("www.","");
        },
        isValidImageUrl: function (url, callback) {
            let img = new Image();
            img.onload = function() {
                callback(true);
            };
            img.onerror = function() {
                callback(false);
            };
            img.src = url;
        },
        isMobileOrTablet: function () {
            let ua = navigator.userAgent || navigator.vendor || window.opera;

            // iPad detection (including iPadOS 13+ where UA includes Macintosh but has touch support)
            let isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

            // Android tablet (Android without 'Mobile' in UA)
            let isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);

            // General mobile (phones, iPod, etc.)
            let isMobile = /Android.+Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|webOS/i.test(ua);

            return isIpad || isAndroidTablet || isMobile;
        },
        getParameterFromUrl: function(parameter, urlValue) {
            let url = new URL(urlValue);
            return url.searchParams.get(parameter) ?? null;
        }
    }
}(window);

/* Help Center - old or new */
(function() {
    jQuery(document).ready(function () {
        jQuery.post(
            ajaxurl,
            {'action': 'ajax_requests_nonce'},
            function(response) {
            if ( response !== '' ){
                tmAjaxActionNonce = response;
            }
        });
    });
})();

